module.exports = __webpack_public_path__ + "img/p3_6.7739d92d.webp";